<template>
    <div>
         <h2>Página no encontrada</h2>
        <Alert :text="'Credenciales incorrectas'" :tiempo="2000" :color="'red'"/>
    </div>
   
    
</template>

<script>
import Alert from "../components/common/Alert.vue"
export default {
    components:{
        Alert
    },
    data(){
        return{
           
        }
      
    }
}
</script>

<style>

</style>